import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setClergyBioSettings } from '../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../root/tcsm-model';

export function useClergyBioSettings(clergyBioSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.clergyBioSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, clergyBioSettingsId, { guid }, language, false, setClergyBioSettings));
		}
	
	}, []);

	return epiApiState?.clergyBioSettingsState?.contentLoaded;	
}